import React from 'react'

export default () => (
  <div className="container-fluid">
    <h1>Coming soon!</h1>
  </div>
)
